export enum Lengths {
  EMAIL = 256,
  PHONE = 32,
  DESCRIPTION = 256,
  NAME = 26,
  MIN_3 = 3,
  LONG = 1024,
}
